module.exports = __webpack_public_path__ + "media/images/user/disclaimers/icon_up-4feb3304da2cf30ba7def7c1e3892778.png";